import { Box, Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import PageHero from '../components/common/PageHero';
import InquiryForm from '../components/forms/InquiryForm';

export default function Anfrage() {
  return (
    <>
      <Helmet>
        <title>Anfrage senden — Süd Ausbau GmbH</title>
        <meta name="description" content="Senden Sie uns Ihre Projektanfrage. Kostenlose Beratung und unverbindliches Angebot für Innenausbau, Umbau und Sanierung." />
      </Helmet>

      <PageHero
        overline="Kontakt"
        title="Ihre Anfrage an uns"
        description="Beschreiben Sie Ihr Projekt — wir melden uns innerhalb von 24 Stunden."
      />

      <Box sx={{ py: { xs: 6, md: 10 } }}>
        <Container maxWidth="md">
          <InquiryForm />
        </Container>
      </Box>
    </>
  );
}
